
import { controls } from '~/mixins/modal'

export default {
  mixins: [controls],
  props: {
    blok: {
      type: Object,
      default: () => {},
    },
    // hideClose: {
    //   type: Boolean,
    //   default: false,
    // },
  },
}
